import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { ImportService } from '@services/imports/import.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';

@Component({
    selector: 'app-failed-imports',
    templateUrl: './failed-imports.component.html',
    styleUrls: ['./failed-imports.component.scss'],
    providers: [ImportService],
    standalone: false
})
export class FailedImportsComponent implements OnInit {

  public title = 'Failed imports';

  public pageActions: PageAction[];

  public importTypeId: string;

  public columns = [

    { prop: 'title', name: 'Title' },
    {
      prop: 'lastSuccessed', name: 'Last Successed', valueTransformer: function(date) {
        return !!date ? moment(date).format('DD-MM-YYYY  HH:mm') : null;
      }
    },
    {
      prop: 'lastFailed', name: 'Last Failed', valueTransformer: function(date) {
        return !!date ? moment(date).format('DD-MM-YYYY  HH:mm') : null;
      }
    },
    { prop: 'failCount', name: 'Fail Count' }
  ];

  public params: any;

  constructor(
    public importService: ImportService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.importTypeId = this.route.snapshot.params['id'];
    this.params = {
      wasLastSuccessful: false
    };
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['imports', event.row._id]);
  }

  public onCustom(event: DataTableEvent): void {
    this.router.navigate(['import-logs/', 'importId', event.row._id]);
  }
}
